import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip, Grid, Label, LabelSize } from '@as/cotopaxi';
import { BasketButtonError } from '@as-react/common-types';
import { InfoIcon } from '@yonderland/andes-icons';
import { Stack } from '@yonderland/andes-react';
import { Box, Icon, TextAlpha, useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { PRODUCT_SIZE_CHIP_INNER_PADDING } from '../../../constants/ProductConstants';
import { getSizeButtonsError } from '../../../util/ProductUtil';
import { ScrollUtil } from '../../../util/ScrollUtil';
export const SizeSelectButtonsFull = ({ id, selectedSku, selectSize, isNotifyMeSizeError, options, filteredSizes, basketValidationState, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const selectedSize = selectedSku && filteredSizes.find(option => option.sku === selectedSku);
    const [errorMessage, setErrorMessage] = useState();
    const chipSize = `${Math.max(...options.map(s => s.label.toString().length))}ch + ${PRODUCT_SIZE_CHIP_INNER_PADDING}px`;
    useEffect(() => {
        if (basketValidationState === BasketButtonError.SKU_OPEN_SIZE_SELECT ||
            basketValidationState === BasketButtonError.SKU ||
            isNotifyMeSizeError) {
            ScrollUtil.scrollToErrorElement(document.getElementById(id), isDesktop, () => {
                setErrorMessage(getSizeButtonsError(basketValidationState));
            });
        }
    }, [basketValidationState]);
    const getButtonState = (option) => {
        if (option.disabled)
            return 'disabled';
        if (errorMessage && (!option.isSoldOut || (option.isSoldOut && isNotifyMeSizeError)))
            return 'error';
        if (option.value === selectedSku)
            return 'activated';
        return 'enabled';
    };
    const handleButtonClick = (option) => () => {
        if (option.disabled)
            return;
        setErrorMessage(undefined);
        selectSize({ sku: option.value.toString(), isSoldOut: option.isSoldOut });
    };
    const buttonOptions = useMemo(() => options.map(option => (_jsx(Chip, { state: getButtonState(option), text: option.isSoldOut ? (_jsx(TextAlpha, { as: "span", strike: true, variant: "inherit", children: option.label })) : (option.label), onClick: option.disabled ? undefined : handleButtonClick(option), noInlinePadding: true }, option.value.toString()))), [options]);
    return (_jsxs(Box, { id: id, testId: id, children: [selectedSize &&
                selectedSize.fullCommercialSize &&
                !options.find(size => size.label === selectedSize.fullCommercialSize) ? (_jsxs(Stack, { gap: "2", children: [_jsx(Label, { size: LabelSize.MINOR, emphasized: true, children: t('pdp.size.buttons.label') }), _jsx(TextAlpha, { as: "span", children: selectedSize.fullCommercialSize })] })) : (_jsx(Label, { size: LabelSize.MINOR, emphasized: true, children: t('pdp.size.buttons.label') })), _jsx(Box, { paddingBlock: "2", children: _jsx(Grid, { scalable: {
                        min: `calc(${chipSize})`,
                        maxCols: options.length <= 2 ? { mobile: 2, desktop: 3 } : { mobile: 4, desktop: 6 },
                        repeatPattern: options.length <= 2 ? 'auto-fill' : undefined,
                    }, gap: "s", dataQA: "size-select-buttons", children: buttonOptions }) }), errorMessage && (_jsxs(Stack, { wrap: "wrap", children: [_jsx(Icon, { source: InfoIcon, color: "error" }), ' ', _jsx(TextAlpha, { as: "span", color: "error", children: t(errorMessage) })] }))] }));
};
